import type { CommonResponse } from '@/types/responseModel';
import { Request } from '@/utils/request';

import type { HOMEPAGE_STATUS } from './homePage';

export interface IBringInfoResponse {
  claimAccountNum: number;
  claimRewardNum: number;
  unclaimRewardNum: number;
  fullyRegisteredAccountNum: number;
  activeAccountNum: number;
}

// 邀请好友领取奖励
export function getReferralRewards() {
  return Request<CommonResponse<IBringInfoResponse>>({
    url: '/rest/os/referral/query/detail',
    method: 'get'
  });
}

// 领取奖励
export function claimReferralRewards() {
  return Request<CommonResponse<any>>({
    url: '/rest/os/referral/claim/rewards',
    method: 'post',
    data: { type: 'all' }
  });
}

// 和好友绑定
export function BindFriend(userId: string) {
  return Request<CommonResponse<any>>({
    url: '/rest/os/referral/bind',
    method: 'post',
    data: { referralUserId: userId }
  });
}

// 是否有绑定
export function getIsBind() {
  return Request<CommonResponse<string>>({
    url: '/rest/os/referral/query/bind/userId',
    method: 'get'
  });
}

export interface IInviterInfo {
  name?: string;
  userId?: string;
  ogImage?: string;
  avatar?: string;
  homepage?: {
    cover?: string;
    video?: string;
    route?: string;
    status?: HOMEPAGE_STATUS;
  };
}

// 通过userId查询相关信息
export function getInviteInfo(userId: string) {
  return Request<CommonResponse<IInviterInfo>>({
    url: '/rest/os/mind/public/profile',
    method: 'get',
    params: {
      userId
    }
  });
}
